import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './containers/App';
import './index.css'
import reportWebVitals from './reportWebVitals';
import EmailVerification from 'containers/Form/EmailVerification/EmailVerification';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/`} element={<App />} />
        <Route path={`${process.env.PUBLIC_URL}/emailVerified`} element={<EmailVerification />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
